export enum Type {
    FREE = 'free',
    TRIAL = 'trial',
    PAID = 'paid'
}
